import { TrustAPI } from '@/shared/modules/trust-api';
import { BankView } from '@/shared/modules/typescript-trustapi-client/models';
import { Options, Vue } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import { orderBy } from "lodash";
import { EventEmitter } from 'events';
import store from '@/trust-admin-app/store';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import BankAuditTrailModal from './bank-audit-trail-modal/index.vue';
import AddEditBankModal from './add-edit-modal/index.vue';
@Options({
  components: {
    AddEditBankModal,
    BankAuditTrailModal,
    LoadingIndicator,
    ErrorIndicator
  }
})
export default class TrustDataBank extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private tableHeadings = [
    { text: 'Name', value: 'name', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private selectedBank: BankView = {
    id: null,
    name: null,
    description: null,
    status: null
  };

  private searchKeyword = '';
  private showActiveOnly = true;
  private showAddEditModal = false;
  private showAuditTrailModal = false;
  private loadingContent = false;
  private errorLoadingContent = false;


  private bankList: BankView[] = [];

  created(): void {
    this.loadBankList();
  }

  mounted() {
    this.eventCtrl.on('reload-banks', this.loadBankList);
  }

  beforeUnmount() {
    this.eventCtrl.off('reload-banks', this.loadBankList);
  }

  private async loadBankList(): Promise<void> {
    try {
      this.loadingContent = true;
      this.errorLoadingContent = false;
  
      const resp: any =
        await this.apiService.ConfigTrustApi?.apiV2ConfigTrustGetBanksPost({}, false);
        this.bankList = resp.data.data as BankView[];
        this.bankList = orderBy(
          this.bankList,
          [data => data.name.toLowerCase()],
          ['asc']
        );
    } catch (err) {
      this.errorLoadingContent = true;
      console.log(err);
    } finally {
      this.loadingContent = false;
    }
  }

  private editBank(bank: BankView): void {
    this.selectedBank = bank;
    this.showAddEditModal = true;
  }

  private addBank(): void {
    this.selectedBank = {
      id: 0,
      name: '',
      description: null,
      status: null
    };

    this.showAddEditModal = true;
  }
  
  private viewBankAuditTrail(bank: BankView): void {
    this.selectedBank = bank;
    this.showAuditTrailModal = true;
  }

  get filteredBankList(): BankView[] {
    let bankListTemp: BankView[] = this.bankList;
    if (this.showActiveOnly) {
      bankListTemp = this.bankList.filter(
        x => x.status.name == 'Active'
      );
    }

    if (this.searchKeyword.trim()) {
      bankListTemp = this.bankList.filter(
        x => x.name.toLocaleLowerCase().includes(this.searchKeyword.toLocaleLowerCase())
      );
    }

    return bankListTemp;
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }
}
